import { useQuery } from "@tanstack/react-query";
import { SystemNotifications } from "@graylog/server-api";
import { NOTIFICATIONS_QUERY_KEY } from "components/notifications/constants";
const POLL_INTERVAL = 3e3;
const fetchNotifications = () => SystemNotifications.listNotifications({ requestShouldExtendSession: false });
const useNotifications = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: NOTIFICATIONS_QUERY_KEY,
    queryFn: fetchNotifications,
    refetchInterval: POLL_INTERVAL,
    enabled
  });
  return { data, isLoading };
};
export default useNotifications;
